import SpitialLogin from "../../components/login/wrapper";
import { useNavigate } from "react-router-dom";
import RootLayout from "../layout";

const checkAuth = () => localStorage.getItem("webTvUserToken");

const LoginPage = () => {
  const auth = checkAuth();
  const navigate = useNavigate();

  if (auth) {
    navigate("/profile");
  }

  return (
    <RootLayout>
      <SpitialLogin />
    </RootLayout>
  );
};

export default LoginPage;
